import { Snackbar } from "./component/widget";
import { Loader } from "./component/widget";

export async function showInfo(text) {
    return showNotification({ text: text });
}

export async function showOK(text) {
    return showNotification({ text: text, ok: true });
}

export async function showError(text) {
    return showNotification({ text: text, error: true });
}

export async function showNotification(params) {
    const notification = new Snackbar({
        target: document.body,
        intro: true,
        props: { ...params }
    });
    return notification.open();
}

export async function showNotImplemented() {
    showNotification({ text: "Not yet implemented", error: true });
};

export function showLoader(params) {
    let loader;
    const timeout = setTimeout(() => {
        loader = new Loader({
            target: document.body,
            intro: true,
            props: { ...params }
        });
    }, 100);

    return () => {
        clearTimeout(timeout);
        if (loader)
            loader.$destroy();
    };
}